import React from 'react';
import { Link } from 'react-router-dom';
import '../../css/HomeBanner.css';


const HomeBanner = () => {
    return (
        <div className="home-banner">
            <div className="container-fluid">
                <video className="adjustable-video" src="/assets/videos/Boat_loop.mp4" autoPlay loop muted playsInline />
                <video className="overlay-video" src="/assets/videos/D-Smart.mp4" autoPlay loop muted playsInline />
                <p className="overlay-text">Digital Standard Maritime Radio-communication Training</p>
                <Link to="/basic">
                    <button className="navbar-signup" id="overlay-button">Get Started</button>
                </Link>
            </div>
        </div>
    );
};

export default HomeBanner;